import { StorageCollectionDetail } from "./StorageCollectionDetail.index";

export default StorageCollectionDetail;
